import LectureLessonLecturerListResultModelBase from '../_generated/modelBases/lecture-lesson-lecturer-list-result-model-base';

export default class LectureLessonLecturerListResultModel extends LectureLessonLecturerListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
